import { FC } from "react";
import { DateTime } from "luxon";
import { HugeiconsIcon } from "@hugeicons/react";
import { Clock01Icon } from "@hugeicons-pro/core-stroke-rounded";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";

interface WaitlistLeadIndicatorProps {
  unitTitle?: string | null;
  /** When the lead was created, i.e. when they joined the waitlist. */
  joinedAt?: string | null;
}

const formatJoinedAt = (joinedAt?: string | null): string => {
  if (!joinedAt) return "";
  const parsed = DateTime.fromISO(joinedAt);
  return parsed.isValid ? parsed.toFormat("MMM d") : "";
};

/**
 * Warns the manager that a lead came in through a waitlisted unit, so a lead
 * that can't be toured or applied for yet is recognizable at a glance.
 */
export const WaitlistLeadIndicator: FC<WaitlistLeadIndicatorProps> = ({
  unitTitle,
  joinedAt
}) => {
  const joined = formatJoinedAt(joinedAt);

  return (
    <Tooltip placement="bottom-start">
      <TooltipTrigger className="flex shrink-0 items-center">
        <HugeiconsIcon
          icon={Clock01Icon}
          size={16}
          className="text-warning-500 flex-shrink-0"
        />
      </TooltipTrigger>
      <TooltipContent className="max-w-[280px] rounded-lg border bg-alpha-800 p-4 text-sm text-white z-[50]">
        <p className="font-bold">The unit isn&apos;t available yet.</p>
        <p>
          This lead is on the waitlist for {unitTitle || "this unit"}
          {joined ? `, joined on ${joined}` : ""}.
        </p>
      </TooltipContent>
    </Tooltip>
  );
};
